// Checks that field was not left blank
const required = value => (value ? undefined : 'Required');

export default required;
